module.exports = __webpack_public_path__ + "img/card_img_architektur.719dda80.png";